var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueMonthlyPicker',{attrs:{"value":_vm.value,"placeHolder":_vm.$t('calendar.label_no_date'),"monthLabels":_vm.monthLabels,"dateFormat":"MM/YYYY"},on:{"selected":_vm.selectedMonth}})}
var staticRenderFns = []

export { render, staticRenderFns }